import type { ComponentType, ReactNode } from 'react';
import type { IconProps } from './icons';

// One row of the connection health panel: muted icon + muted label on the left,
// emphasized value on the right (optionally with a hover title for the full value).
interface HealthRowProps {
  Icon: ComponentType<IconProps>;
  label: string;
  value: ReactNode;
  valueTitle?: string;
}

export function HealthRow({ Icon, label, value, valueTitle }: HealthRowProps) {
  return (
    <div className="flex items-center gap-1.5 text-xs">
      <Icon className="w-3.5 h-3.5 flex-shrink-0" style={{ color: 'var(--color-text-muted)' }} />
      <span style={{ color: 'var(--color-text-muted)' }}>{label}</span>
      <span className="ml-auto font-medium" style={{ color: 'var(--color-text)' }} title={valueTitle}>{value}</span>
    </div>
  );
}
